var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3466421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14V2H9V0H1C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447715 16 1 16H9V14H2Z",
    fill: "#747E87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6667 12V9H6V7H11.6667V4L16 8L11.6667 12Z",
    fill: "#747E87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLogout);
export default __webpack_public_path__ + "static/media/icon-user-logout.ca64d9401d8bfda9f4a67368757b7cd1.svg";
export { ForwardRef as ReactComponent };